import React, { useState, useEffect } from "react";
import { adverbData } from "../../../data/vocabularyData/adverbData";
import { adjectiveData } from "../../../data/vocabularyData/adjectiveData";
import { compoundData } from "../../../data/vocabularyData/compoundData";
import { testWordsData } from "../../../data/vocabularyData/testWordsData";
import { verbData } from "../../../data/vocabularyData/verbData";
import "../../../styles/Part5Vocabulary.css";

const Part5Vocabulary = ({ onBack }) => {
  const [selectedCategory, setSelectedCategory] = useState("adverb");
  const [visibleTranslations, setVisibleTranslations] = useState({});
  const [showAllTranslations, setShowAllTranslations] = useState(false);
  const [words, setWords] = useState({});

  const categories = [
    { id: "adverb", name: "부사", data: adverbData },
    { id: "adjective", name: "형용사", data: adjectiveData },
    { id: "compound", name: "복합명사", data: compoundData },
    { id: "testWords", name: "명사", data: testWordsData },
    { id: "verb", name: "동사", data: verbData },
  ];

  useEffect(() => {
    const category = categories.find((cat) => cat.id === selectedCategory);
    setWords({ ...words, [selectedCategory]: category.data });
  }, []);

  const handleCategoryChange = (categoryId) => {
    setSelectedCategory(categoryId);
    if (!words[categoryId]) {
      const category = categories.find((cat) => cat.id === categoryId);
      setWords({ ...words, [categoryId]: category.data });
    }
  };

  const getCurrentData = () => {
    return words[selectedCategory] || [];
  };

  const removeWord = (wordId) => {
    setWords((prev) => ({
      ...prev,
      [selectedCategory]: prev[selectedCategory].filter(
        (word) => word.id !== wordId
      ),
    }));
  };

  const toggleTranslation = (wordId) => {
    setVisibleTranslations((prev) => ({
      ...prev,
      [wordId]: !prev[wordId],
    }));
  };

  const toggleAllTranslations = () => {
    setShowAllTranslations(!showAllTranslations);
    const currentData = getCurrentData();
    const newVisibleTranslations = {};

    currentData.forEach((word) => {
      newVisibleTranslations[word.id] = !showAllTranslations;
    });

    setVisibleTranslations(newVisibleTranslations);
  };

  return (
    <div className="vocabulary-container">
      <button className="back-button" onClick={onBack}>
        뒤로 가기
      </button>

      <div className="category-buttons">
        {categories.map((category) => (
          <button
            key={category.id}
            className={`category-button ${
              selectedCategory === category.id ? "active" : ""
            }`}
            onClick={() => handleCategoryChange(category.id)}
          >
            {category.name}
          </button>
        ))}
      </div>

      <table className="vocabulary-table">
        <thead>
          <tr>
            <th>English (영단어 클릭시 목록에서 제거)</th>
            <th onClick={toggleAllTranslations} style={{ cursor: "pointer" }}>
              한글{" "}
              {showAllTranslations
                ? "(클릭시 모두 숨기기)"
                : "(클릭시 모두 보기)"}
            </th>
          </tr>
        </thead>
        <tbody>
          {getCurrentData().map((word) => (
            <tr key={word.id}>
              <td
                className="english-cell"
                onClick={() => removeWord(word.id)}
                style={{ cursor: "pointer" }}
              >
                {word.english}
              </td>
              <td
                className={`korean-cell ${
                  visibleTranslations[word.id] ? "visible" : "hidden"
                }`}
                onClick={() => toggleTranslation(word.id)}
              >
                {word.korean}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Part5Vocabulary;
